import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, Box } from '@material-ui/core';
import RecommendedCourses from './sections/RecommendedCourses/RecommendedCourses';
import PurchasedCourses from './sections/PurchasedCourses/PurchasedCourses';
import AdditionalProgramsSupportMessage from '../../../../Common/AdditionalProgramsSupportMessage/AdditionalProgramsSupportMessage';
import AppContext from '../../../../../Context/AppContext';
import configData from '../../../../../config.json';
import './NewModules.css';

const getDevMockCourses = () => {
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }
    const mockParam = new URLSearchParams(window.location.search).get(
        'mockCourses'
    );
    if (!mockParam) {
        return null;
    }
    if (mockParam === '0') {
        return [];
    }
    const courses = [
        {
            id: 1009,
            title: 'Mind & Body Coach Certification',
            purchased: true,
            imageUrl: '',
            isCoachCertification: true,
        },
        {
            id: 1002,
            title: 'Oola Coaching Certification',
            purchased: true,
            imageUrl: '',
            isCoachCertification: false,
        },
    ];
    return mockParam === '2' ? courses : [courses[0]];
};

const NewModules = (props) => {
    const { checkUserSession, updateAdditionalCourse, changeLoading } =
        useContext(AppContext);
    const [listNewCourse, setListNewCourse] = useState([]);
    const [listActiveCourse, setListActiveCourse] = useState([]);
    const [activeCourse, setActiveCourse] = useState({});
    const [init, setInit] = useState(false);

    useEffect(() => {
        const mockCourses = getDevMockCourses();
        if (mockCourses) {
            setListActiveCourse(mockCourses);
            setActiveCourse(mockCourses[0]);
            changeLoading(false);
            setInit(true);
            return undefined;
        }

        changeLoading(true);
        const url = `${configData.SERVER_URL}AdditionalCourse/GetCourses`;
        const { token, additionalCourse, displayCoachCertificationTutorial } =
            checkUserSession();
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((result) => {
                const arrItems = result.data;

                if (arrItems.filter((x) => x.purchased === true).length === 1)
                    setActiveCourse(
                        arrItems.filter((x) => x.purchased === true)[0]
                    );
                setListActiveCourse(
                    arrItems.filter((x) => x.purchased === true)
                );
                if (additionalCourse != null) {
                    setActiveCourse(additionalCourse);
                }
                if (displayCoachCertificationTutorial) {
                    setActiveCourse(arrItems.filter((x) => x.id === 1009)[0]);
                }
                
                // Si hay un curso por defecto establecido para coaches activos
                const defaultCourseForCoach = localStorage.getItem('DefaultCourseForCoach');
                if (defaultCourseForCoach) {
                    const defaultCourse = arrItems.filter((x) => x.id === parseInt(defaultCourseForCoach))[0];
                    if (defaultCourse) {
                        setActiveCourse(defaultCourse);
                        // Limpiar el localStorage después de un delay para que no se aplique en futuras visitas
                        setTimeout(() => {
                            localStorage.removeItem('DefaultCourseForCoach');
                            localStorage.removeItem('CoachFromSteps');
                            // NO limpiar userStepId e isActiveCoach para que MyBreakthrough pueda usarlos
                        }, 1000);
                    }
                }
                changeLoading(false);
                setInit(true);
            })
            .catch((error) => {
                changeLoading(false);
                setInit(false);
                console.log(error);
            });
    }, []);

    if (!init) {
        return <div className="init_loading">Loading...</div>;
    }

    return (
        <div className="NewModules__Container">
            <section className="paragraph-3 ModuleDescription">
                <p className="TitleContentElearning">Additional Programs</p>
                Accelerate your journey to your Oola life with these additional
                courses.
            </section>
            {init && listActiveCourse.length === 0 && (
                <AdditionalProgramsSupportMessage />
            )}
            {listActiveCourse.length > 0 && (
                <>
                    <h1 className="NewModules__title">
                        {listActiveCourse.length > 1
                            ? 'PURCHASED'
                            : listActiveCourse[0].title}
                    </h1>
                    {listActiveCourse.length > 1 && (
                        <Autocomplete
                            disablePortal
                            options={listActiveCourse}
                            getOptionLabel={(option) => option.title || ''}
                            value={activeCourse?.id ? activeCourse : null}
                            sx={{ width: 300 }}
                            onChange={(event, newValue) => {
                                const selected =
                                    newValue != null
                                        ? newValue
                                        : listActiveCourse[0];
                                updateAdditionalCourse(selected);
                                setActiveCourse(selected || {});
                            }}
                            filterOptions={(options) => options}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select your program"
                                />
                            )}
                            renderOption={(propsx) => (
                                <Box
                                    component="li"
                                    sx={{
                                        '& > img': { mr: 2, flexShrink: 0 },
                                    }}
                                    {...propsx}
                                >
                                    {propsx.isCoachCertification && (
                                        <h5>Certifications</h5>
                                    )}
                                    <img
                                        loading="lazy"
                                        width="80"
                                        height="40"
                                        src={`${configData.SERVER_URL_IMG}${propsx.imageUrl}`}
                                        srcSet={`${configData.SERVER_URL_IMG}${propsx.imageUrl}`}
                                        alt="Module"
                                    />
                                    &nbsp;&nbsp;
                                    {propsx.title}
                                </Box>
                            )}
                        />
                    )}
                    <br />
                    {listActiveCourse
                        .filter((x) => x.id === activeCourse.id)
                        .map((item) => (
                            <PurchasedCourses
                                key={`RecommendedCoursesId${item.id}`}
                                item={item}
                            />
                        ))}
                </>
            )}
        </div>
    );
};

export default NewModules;
